import React from 'react';
import './PageRootNav.css';

const PageRootNav = props => {
    return <h1 className="display-4">{props.label}</h1>;
};
export default PageRootNav;
